import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { AuthProvider } from './auth/AuthProvider';
import { HelpProvider } from './help/HelpProvider';
import { ThemeProvider } from './theme/ThemeProvider';
import { ToastProvider } from './components/Toast';
import { ErrorBoundary } from './components/ErrorBoundary';
import { TourProvider } from './tours/TourProvider';

/**
 * DeployHub application root.
 *
 * Composition order:
 * - {@link ThemeProvider} owns the light/dark/auto theme applied to `<html>`.
 * - {@link BrowserRouter} provides routing for the whole tree.
 * - {@link AuthProvider} owns the session and restores it from a stored token.
 * - {@link HelpProvider} renders the global contextual-help drawer.
 * - {@link TourProvider} owns the guided-tour launcher and the one-shot
 *   first-run auto-start (item 7.6).
 *
 * Real features grow inside the routed {@link AppRoutes} / app shell.
 */
export function App(): JSX.Element {
  return (
    <ThemeProvider>
      <ToastProvider>
        {/* Last-resort boundary: catches a catastrophic crash above the routed
            content (shell/providers) so even that degrades to a recoverable
            notice rather than a blank document. */}
        <ErrorBoundary label="app-root">
          <BrowserRouter>
            <AuthProvider>
              <HelpProvider>
                <TourProvider>
                  <AppRoutes />
                </TourProvider>
              </HelpProvider>
            </AuthProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
